import { render, staticRenderFns } from "./SizeLink.vue?vue&type=template&id=d9022422&"
import script from "./SizeLink.vue?vue&type=script&lang=js&"
export * from "./SizeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports